import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Expired session on a staff page → send to login instead of silently rendering empty data.
const PUBLIC_PREFIXES = ["/login", "/qp/", "/sign/", "/terms/", "/fbsign/s/"];
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    const path = window.location.pathname;
    if (err.response?.status === 401 && !url.startsWith("/auth/") && !PUBLIC_PREFIXES.some((p) => path.startsWith(p))) {
      window.location.assign(`/login?expired=1&next=${encodeURIComponent(path)}`);
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string")
    return detail.msg;
  return String(detail);
}
